import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-end" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "mr-n2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Add applications to a group to easily assign applications to groups of users within User Management.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateGroup = _resolveComponent("CreateGroup")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_AssignApplications = _resolveComponent("AssignApplications")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      justify: "space-between",
      align: "center",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              align: "center",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "#F4F4F4",
                      variant: "flat",
                      class: "pa-2",
                      height: "48"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          dense: "",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              md: "8"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  align: "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "5",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CreateGroup, {
                                          system: true,
                                          disabled: _ctx.disabled,
                                          group: _ctx.group,
                                          loading: _ctx.loading,
                                          "reset-dialog": _ctx.resetDialog,
                                          removeApplicationAccessFromGroup: _ctx.removeApplicationAccessFromGroup,
                                          onFetchGroups: _ctx.fetchSystemGroups
                                        }, null, 8, ["disabled", "group", "loading", "reset-dialog", "removeApplicationAccessFromGroup", "onFetchGroups"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "5",
                                      md: "auto"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_dialog, { width: "500" }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn, _mergeProps({ color: "primary" }, props, {
                                              size: "small",
                                              variant: "plain",
                                              disabled: !_ctx.selectedGroups.length
                                            }), {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.mdAndUp ? 'Remove system groups' : 'Remove'), 1)
                                              ]),
                                              _: 2
                                            }, 1040, ["disabled"])
                                          ]),
                                          default: _withCtx(({ isActive }) => [
                                            _createVNode(_component_v_card, { "max-width": "460" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode("Remove " + _toDisplayString(_ctx.selectedGroups.length) + " system group" + _toDisplayString(_ctx.selectedGroups.length > 1 ? 's' : '') + "?", 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_text, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Are you sure you want to remove these system groups? Groups cannot have applications or users assigned, in order to be deleted. ")
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_card_actions, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_btn, {
                                                      onClick: ($event: any) => (isActive.value = false)
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Cancel ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                      loading: _ctx.loading,
                                                      disabled: _ctx.loading,
                                                      color: "primary",
                                                      onClick: ($event: any) => {_ctx.removeSystemGroups(); isActive.value = false}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Remove ")
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["loading", "disabled", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              md: "4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          "hide-details": "",
                                          density: "compact",
                                          placeholder: "Search system groups",
                                          "append-inner-icon": "mdi-magnify",
                                          modelValue: _ctx.searchNames,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchNames) = $event)),
                                          variant: "underlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_data_table, {
      "sort-by": [{key: 'name', order: 'asc'}],
      items: _ctx.groups,
      headers: _ctx.headers,
      "show-select": "",
      "return-object": "",
      modelValue: _ctx.selectedGroups,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedGroups) = $event)),
      height: "calc(100vh - 260px)"
    }, {
      [`item.users`]: _withCtx(({ item }) => [
        _createVNode(_component_v_chip, {
          color: "primary",
          variant: "flat",
          size: "small",
          class: "font-weight-bold"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.userCount || 0) + " user" + _toDisplayString(item.userCount > 1 || item.userCount === 0 ? 's' : '') + " in " + _toDisplayString(_ctx.accounts.length) + " account" + _toDisplayString(_ctx.accounts.length > 1 || _ctx.accounts.length === 0 ? 's' : ''), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.actions`]: _withCtx(({ item }) => [
        _createVNode(_component_v_menu, null, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_btn, _mergeProps(props, {
                size: "32",
                icon: "",
                variant: "flat",
                color: "primary"
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-dots-vertical")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, { density: "compact" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => {_ctx.currentGroup = {...item}; _ctx.editGroup(item);},
                  "prepend-icon": "mdi-pencil",
                  title: "Edit group"
                }, null, 8, ["onClick"]),
                _createVNode(_component_v_list_item, {
                  onClick: ($event: any) => {_ctx.currentGroup = {...item}; _ctx.editGroupApplicationsDialog = true;},
                  "prepend-icon": "mdi-application-edit",
                  title: "Edit applications"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      [`item.applications`]: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications, (app, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-flex",
              key: app.id
            }, [
              _createElementVNode("div", _hoisted_3, [
                (index < 5)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      text: app.name,
                      location: "bottom",
                      "open-delay": "200"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          size: "32",
                          style: {"border":"2px solid #ffffff"},
                          icon: "",
                          variant: "flat",
                          color: "primary",
                          onClick: ($event: any) => {_ctx.currentGroup = {...item}; _ctx.currentApplication = app; _ctx.removeAppDialog = true;}
                        }), {
                          default: _withCtx(() => [
                            (!app.icon)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(app.name.charAt(0)), 1))
                              : (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 1,
                                  color: "white",
                                  size: "18"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-" + _toDisplayString(app.icon), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                          ]),
                          _: 2
                        }, 1040, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["text"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          (item.applications.length > 5)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 0,
                location: "bottom",
                "open-delay": "200"
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _mergeProps(props, { class: "ml-4" }), [
                    _createElementVNode("a", _hoisted_5, "+ " + _toDisplayString(item.applications.length - 5) + " more", 1)
                  ], 16)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.applications.slice(5), (app) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: app.id
                    }, _toDisplayString(app.name), 1))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, 1032, ["items", "headers", "modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.removeAppDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.removeAppDialog) = $event))
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { "max-width": "460" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Remove " + _toDisplayString(_ctx.currentApplication.name) + " from " + _toDisplayString(_ctx.currentGroup.name) + "?", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Are you sure you want to remove this application from this group? This group must have no assigned users in any account in order to be deleted. ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: ($event: any) => (isActive.value = false)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_v_btn, {
                  loading: _ctx.loading,
                  disabled: _ctx.loading,
                  color: "primary",
                  onClick: ($event: any) => {_ctx.removeApplicationAccessFromGroup(_ctx.currentApplication, true); isActive.value = false}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Remove ")
                  ]),
                  _: 2
                }, 1032, ["loading", "disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editGroupDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editGroupDialog) = $event))
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { title: "Edit system group" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              "hide-details": "",
                              density: "compact",
                              label: "Group name",
                              modelValue: _ctx.currentGroup.name,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentGroup.name) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  loading: _ctx.loading,
                  disabled: _ctx.disabled,
                  color: "primary",
                  onClick: ($event: any) => {_ctx.saveSystemGroup(); isActive.value = false}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save system group ")
                  ]),
                  _: 2
                }, 1032, ["loading", "disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.editGroupApplicationsDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editGroupApplicationsDialog) = $event)),
      onAfterLeave: _ctx.resetDialog
    }, {
      default: _withCtx(({  }) => [
        _createVNode(_component_v_card, { title: "And or remove group applications" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_AssignApplications, {
                  currentGroup: _ctx.currentGroup,
                  onUpdateAppsToAdd: _cache[5] || (_cache[5] = ($event: any) => (_ctx.appsToAdd = $event)),
                  removeApplicationAccessFromGroup: _ctx.removeApplicationAccessFromGroup
                }, null, 8, ["currentGroup", "removeApplicationAccessFromGroup"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateApplicationAccessForGroup(_ctx.currentGroup))),
                  loading: _ctx.loading,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Save group ")
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onAfterLeave"])
  ]))
}